import React from "react";

const TripMeterStoppedBadge = ({ className = "" }) => (
  <span
    className={`font-UbuntuMedium text-red-600 ${className}`.trim()}
    title="Meter sensor issue — meter stopped"
  >
    Meter stopped
  </span>
);

const TripMeterWorkingBadge = ({ className = "" }) => (
  <span
    className={`font-UbuntuMedium text-green-700 ${className}`.trim()}
    title="Meter sensor OK"
  >
    Working
  </span>
);

const TripMeterStatusBadge = ({ stopped, className = "" }) =>
  stopped ? (
    <TripMeterStoppedBadge className={className} />
  ) : (
    <TripMeterWorkingBadge className={className} />
  );

export default TripMeterStatusBadge;
